import styled from 'styled-components';
import { FAMILY_FONT_PRIMARY, TITLE_SIZE_4, TITLE_SIZE_5, TITLE_SIZE_3 } from '../../const/text';
import {
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  SECONDARY_COLOR_2
} from '../../const/color';
import { device } from '../../const/device';

export const Item = styled.div<{ active?: boolean, themeColor: string }>`
  font-size: ${TITLE_SIZE_4}px;
  font-family: ${FAMILY_FONT_PRIMARY};
  color: ${props => props.themeColor == "black"?({ active }) => active ? '#ffffff' : SECONDARY_COLOR_2:({ active }) => active ? SECONDARY_COLOR : SECONDARY_COLOR_2};
  cursor: ${({ active }) => active ? 'default' : 'pointer'};
  margin-right: 35px;
  position: relative;
  letter-spacing: 0.005em;
  text-transform: uppercase;
  
  &:hover {
    color: ${props => props.themeColor == "black"?'#ffffff':SECONDARY_COLOR};
  }
  
  &:before {
    display: ${({ active }) => active ? 'block' : 'none'};
    content: '';
    bottom: -10px;
    left: 0;
    position: absolute;
    width: 100%;
    height: 3px;
    background: ${PRIMARY_COLOR};
  }

  @media (${device.tablet}) {
   // font-size: ${TITLE_SIZE_3}px;
  }

  
  @media (${device.mobileL}) {
    font-size: ${TITLE_SIZE_5}px;
    &:before {
      bottom: -7px;
    }
  }
`;

export const Container = styled.div`
  height: 36px;
  align-items: center;
  margin-bottom: 32px;
  position: relative;
  
  @media (${device.mobileL}) {
    height: 24px;
    margin-bottom: 24px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const IconContainer = styled.div`
  position: absolute;
  top: 0px;
  right: 0;
  display:flex;
  > button {
    margin-left: 16px;
  }
`;